import { Component, OnInit } from '@angular/core';
import { Configuration } from '../../../app.constants';
import { AuthService, AppInfoService, PortalStudentLogIn } from '../../../shared/services';
import { AppConfigService } from '../../../app-config.service';
import { Router, ActivatedRoute,NavigationExtras } from '@angular/router';

@Component({
  selector: 'app-meritlink',
  templateUrl: './meritlink.component.html',
  styleUrls: ['./meritlink.component.scss']
})
export class MeritlinkComponent implements OnInit {
  public logoPath :string=""; 
  ElevanthStdScience:string="";
  ElevanthStdCommerce:string="";
  BscSem1st:string="";
  BcomSem1st:string="";
  ElevanthStdScienceMerit:string="";
  ElevanthStdCommerceMerit:string="";
  data:any; 
  MeritArray:any;
  constructor(private configuration: Configuration,
   private AuthService:AuthService,private AppConfigService:AppConfigService,
   private router: Router,private route: ActivatedRoute
    ) { 

    }

  ngOnInit() {
    debugger
    this.MeritArray=this.configuration.MeritArray;
    this.logoPath = this.AppConfigService.LogoPath;
    this.AuthService.GetPdfLinkForMerit()
        .subscribe((data: PortalStudentLogIn[]) => this.data = data,
        error => {
          alert(error);
        },
        () => { 
          if(this.data.length > 0){
            this.ElevanthStdScience = this.data[0].Message
            this.ElevanthStdCommerce=this.data[1].Message;
            this.BscSem1st = this.data[2].Message
            this.BcomSem1st = this.data[3].Message
            this.ElevanthStdScienceMerit = this.data[4].Message
            this.ElevanthStdCommerceMerit=this.data[5].Message;
          }
      }); 
  }
  redirectToLogin(){
    this.router.navigate(['/login-form']);  
  }
}
